import React from 'react';
import { Layout } from '../components/Layout';
import SupportTicketsPanel from '../components/SupportTicketsPanel';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { LifeBuoy } from 'lucide-react';

const ADMIN_EMAILS = [
    'alvaro.mardones.rivera@gmail.com',
    'acontistaeduca@gmail.com',
    'mariuerosima@gmail.com',
    'josesepulvedamorales@gmail.com',
    'sabino@fuix.cl',
];

export default function AdminSoporte() {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && !ADMIN_EMAILS.includes(user.email)) {
            navigate('/dashboard');
        }
    }, [user, navigate]);

    return (
        <Layout>
            <div className="space-y-6 animate-fade-in">
                <div>
                    <div className="flex items-center gap-2">
                        <LifeBuoy className="h-6 w-6 text-slate-700" />
                        <h1 className="font-heading text-2xl font-bold text-slate-900 md:text-3xl" data-testid="admin-soporte-title">
                            Soporte
                        </h1>
                    </div>
                    <p className="mt-1 text-slate-500">
                        Bandeja centralizada de tickets enviados por docentes
                    </p>
                </div>
                <SupportTicketsPanel />
            </div>
        </Layout>
    );
}
